/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Sipay_BodyInputs */

const tr_mesafeli_s11_sipay_body = /** @type {(inputs: Mesafeli_S11_Sipay_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanal POS ve kart ile tahsilat.`)
};

const en_mesafeli_s11_sipay_body = /** @type {(inputs: Mesafeli_S11_Sipay_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanal POS and card collection.`)
};

const de_mesafeli_s11_sipay_body = /** @type {(inputs: Mesafeli_S11_Sipay_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanal POS und Karteneinzug.`)
};

const ru_mesafeli_s11_sipay_body = /** @type {(inputs: Mesafeli_S11_Sipay_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanal POS и списание по карте.`)
};

/**
* | output |
* | --- |
* | "Sanal POS and card collection." |
*
* @param {Mesafeli_S11_Sipay_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_sipay_body = /** @type {((inputs?: Mesafeli_S11_Sipay_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Sipay_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_sipay_body(inputs)
	if (locale === "de") return de_mesafeli_s11_sipay_body(inputs)
	if (locale === "ru") return ru_mesafeli_s11_sipay_body(inputs)
	return tr_mesafeli_s11_sipay_body(inputs)
});